import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonBrands = () => {
    return (
        <div className="skeleton-brands-wrapper">
            <div className="container">
                <div className="brand-header">
                    <div className="more-icon d-flex justify-content-end"><IconName name="chevron_left" className="icon"/></div>
                    <div className="border-slider xmt-2"></div>
                </div>
                <div className="slider-wrapper">
                    <div className="slider-box xmt-6 d-flex align-items-center">
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                    </div>
                    <div className="slider-box xmt-4 d-flex align-items-center">
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                        <div className="slide-sk skeleton-loading"></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SkeletonBrands;
